import './image-text.scss';
import Swiper from 'swiper/bundle';

export default () => {
	//Swiper
	new Swiper('.js-image-text-slider', {
		speed: 1000,
		loop: true,
		slidesPerView: 1,
		effect: 'fade',
		navigation: {
			nextEl: ".image-text-button-next",
			prevEl: ".image-text-button-prev",
		},
		autoplay: {
			delay: 3000,
		},
	});
};
